import "../phaser.min.js";
import Common from "../Includes/Common.js";
import SelectionScene from "./SelectionScene.js";
class Start extends Phaser.Scene {
    constructor() {
        super('Start');
        this.common = new Common();
    }

    preload() {

    }

    create() {
        this.subtitle = this.add.text(Math.floor(this.scale.width / 2), Math.floor(this.scale.height / 12 * 4.5),
                'Street Smart',
                {
                    fontFamily: this.common.font,
                    fontSize: 250,
                    textAlign: 'center'
                })
                .setOrigin(0.5)

        this.title = this.add.text(Math.floor(this.scale.width / 2), Math.floor(this.scale.height / 12 * 6.5),
                'Trivia',
                {
                    fontFamily: this.common.font,
                    fontSize: 250,
                    textAlign: 'center'
                })
                .setOrigin(0.5)



        this.tweens.add({
            targets: [this.title, this.subtitle],
            y: '+=' + Math.floor(this.scale.height / 12 * 0.25),
            duration: 500,
            ease: 'easeInCubic',
            yoyo: true,
            repeat: 2,
            onComplete: () => {
                this.scene.add('SelectionScene', SelectionScene)
                this.scene.start('SelectionScene');
                this.scene.moveBelow('Ui', 'SelectionScene');
            }
        })
    }

    update() {
    }
}

export default Start;